import { render } from "./FancyLoader.vue?vue&type=template&id=43a10c5a&scoped=true"
const script = {}

import "./FancyLoader.scss?vue&type=style&index=0&id=43a10c5a&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a10c5a"]])

export default __exports__